import React from "react";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
} from "../../../../../../shared/helpers/utils";
const SubHeader = ({reportData,subtext="COMPARABLE SALES REPORT"}) => {
  const { buildingRes, compSettings  } = reportData;
  
  const buildingNameOrAdr = buildingRes.name 
  ? _capitalizeText(buildingRes.name)
  : buildingRes.display_full_street_address
    ? _capitalizeText(buildingRes.display_full_street_address)
    : _capitalizeText(buildingRes.full_street_address);
  const currentDate = new Date();
  const options = { year: 'numeric', month: 'long' };
  const formattedDate = currentDate.toLocaleDateString('en-US', options);  
    
  return (
    <div className="sub_header">
      <h3 className="editable building-location"> {buildingNameOrAdr}  {compSettings && compSettings.propertyDetails && compSettings.propertyDetails.property && compSettings.propertyDetails.property.address_2_normalized ? ' - ' + compSettings.propertyDetails.property.address_2_normalized.toUpperCase().replace("APT ", "") : ""}</h3>
      <h3 className="header-text heading-location editable">
        {`${_capitalizeText(buildingRes.neighborhood)}, ${_capitalizeText(buildingRes.borough)}`.toUpperCase()}
      </h3>
      <div className="date_comp">
        <div className="editable">{subtext}</div>
        <div></div>
        <div className="editable">{formattedDate}</div>
      </div>
    </div>
  );
};
export default SubHeader;
